export default __webpack_public_path__ + "static/media/tiktok.f9ff993a.svg";